export const ACCESS_CONTROL_PROVIDERS = {
  brivo: { value: 'brivo', label: 'Brivo' },
  comelit: { value: 'comelit', label: 'Comelit' },
  smartair: { value: 'smartair', label: 'SmartAir' },
  two_n: { value: 'two_n', label: '2N' },
  akuvox: { value: 'akuvox', label: 'Akuvox' },
  bmx: { value: 'bmx', label: 'BMX' },
  dormakaba: { value: 'dormakaba', label: 'Dormakaba' },
  lyazon: { value: 'lyazon', label: 'Lyazon' },
  zerv: { value: 'zerv', label: 'Zerv' },
  salto: { value: 'salto', label: 'Salto' },
  keyscan: { value: 'keyscan', label: 'Keyscan' },
};

export const CAMERA_PROVIDERS = {
  eagle_eye: { value: 'eagle_eye', label: 'Eagle Eye' },
};

export const PAYMENTS_PROVIDERS = {
  aptexx: { value: 'aptexx', label: 'Aptexx' },
  clickpay: { value: 'clickpay', label: 'Clickpay' },
  external: { value: 'external', label: 'External' },
};
